export default __webpack_public_path__ + "static/media/landscape32.3315b60d.jpeg";